<template>
  <transition-fade :duration="500" appear>
    <div
      v-if="activeSeasonContentForSchoolLevel"
      id="extra-header"
      class="border-0 border-b border-solid border-gray my-0 mx-[100px] text-center"
    >
      <h1 class="title-block ml-0">
        {{ activeVolume.title }} / {{ activeSeason.issueNumber }}
      </h1>
    </div>
  </transition-fade>
  <transition-fade :duration="500" appear @enter="contentMounted">
    <div
      v-if="activeSeasonContentForSchoolLevel?.extraContent?.length"
      id="extra-content"
      class="max-h-[calc(100vh_-_200px)] overflow-y-auto"
    >
      <template
        v-for="(
          contentItem, index
        ) in activeSeasonContentForSchoolLevel.extraContent"
        :key="index"
      >
        <div v-if="contentItem._rendered" v-html="contentItem._rendered" />
      </template>
    </div>
    <div v-else class="flex h-full justify-center items-center">
      <box-generic header="Geen materiaal">
        <p class="leading-relaxed">
          In deze aflevering zijn er geen materialen<br />
          voor het onderdeel “Extra” beschikbaar.
        </p>
      </box-generic>
    </div>
  </transition-fade>
</template>

<script>
import { mapGetters } from "vuex";

import BoxGeneric from "../../../../components/content/BoxGeneric.vue";
import TransitionFade from "../../../../components/magic/TransitionFade.vue";

import lightboxInitialize from "../../../../components/content/lightbox-initialize";
import lightboxDestroy from "../../../../components/content/lightbox-destroy";

export default {
  name: "ExtraContent",
  components: {
    BoxGeneric,
    TransitionFade,
  },
  computed: {
    ...mapGetters([
      "activeVolume",
      "activeSeason",
      "activeSeasonContentForSchoolLevel",
    ]),
  },
  watch: {
    activeSeasonContentForSchoolLevel() {
      this.$nextTick(() => {
        lightboxDestroy();
        lightboxInitialize();
      });
    },
  },
  beforeUnmount() {
    lightboxDestroy();
  },
  methods: {
    contentMounted() {
      lightboxDestroy();
      lightboxInitialize();
    },
  },
};
</script>
